import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import {
  BasePage,
  TabletScreen,
  MobileScreen,
  StaticContext
} from '@sm/webassets';
import { Grid, Row, Col } from '@sm/wds-react';
import { getClientEnvironmentDetails } from '@sm/utils';

import NavBar from '../components/NavBar';
import AppDirNavHeader from '../components/AppDirNavHeader';

import './app-directory-base-page.scss';

const AppDirectoryBasePage = ({
  id,
  header,
  navbar,
  pageMetricsAttributes,
  children
}) => {
  const { userAgent } = useContext(StaticContext);
  const { isDesktop } = getClientEnvironmentDetails(userAgent);

  return (
    <BasePage
      pageId={id}
      includeHeader={false}
      pageMetricsAttributes={pageMetricsAttributes}
      legacyWeb="papi"
    >
      {header}
      <Grid fluid className="sm-app-directory-base-page">
        <div className="wds-p-l-5 wds-p-r-5">
          <MobileScreen defaultMatches={!isDesktop}>
            <Row>
              <Col>{navbar}</Col>
            </Row>
          </MobileScreen>
          <Row>
            <TabletScreen defaultMatches={isDesktop}>
              <Col lg={3}>{navbar}</Col>
            </TabletScreen>
            <Col>{children}</Col>
          </Row>
        </div>
      </Grid>
    </BasePage>
  );
};

AppDirectoryBasePage.propTypes = {
  id: PropTypes.string.isRequired,
  header: PropTypes.node,
  navbar: PropTypes.node,
  children: PropTypes.node.isRequired,
  pageMetricsAttributes: PropTypes.shape({})
};

AppDirectoryBasePage.defaultProps = {
  header: <AppDirNavHeader />,
  navbar: <NavBar />,
  pageMetricsAttributes: null
};

export default AppDirectoryBasePage;
